const webUrl=value=>{
  if(typeof value!=="string")return null;
  try{const url=new URL(value);return ["https:","http:"].includes(url.protocol)?value:null;}
  catch{return null;}
};
// Candidate IDs remain IDs; never invent an ad URL or use a customer-text URL.
export function observedAdFields(record={}){
  const candidate=record.ad_source_candidate;
  const object=candidate&&typeof candidate==="object"?candidate:{};
  const candidateId=typeof candidate==="string"&&/^\d{8,30}$/.test(candidate)?candidate:
    [object.sourceId,object.adId,object.id].find(value=>/^\d{8,30}$/.test(String(value||"")));
  return {
    ad_source_candidate:candidate||null,
    link_anuncio:webUrl(record.link_anuncio)||webUrl(object.sourceUrl||object.source_url||object.url)
      ||webUrl(candidate)||null,
    id_anuncio_meta:record.id_anuncio_meta||(candidateId?String(candidateId):null),
  };
}
